__turbopack_context__.v({
  "Funnel": "Funnel-module__jX3gva__Funnel",
  "tagsContainer": "Funnel-module__jX3gva__tagsContainer",
});
